import {
  HttpEvent,
  HttpEventCallbacks,
  httpDelete,
  httpGet,
  httpPost,
  httpPut,
} from "@/events/eventsDomain";
import { toQueryString } from "@/utils/queryParams";
import type {
  TemplateDTO,
  TemplateType,
  SaveTemplateRequest,
  SaveTemplateResponse,
  TemplateContent,
  UpdateTemplateRequest,
} from "@/templates/templateDomain";

export type TemplateApiClient = {
  getTemplates: (
    accountId: string,
    companyId: string | undefined,
    type: TemplateType,
    params: HttpEventCallbacks<TemplateDTO[]>,
  ) => HttpEvent<TemplateDTO[]>;
  getContent: (
    templateId: string,
    companyId: string | undefined,
    params: HttpEventCallbacks<TemplateContent>,
  ) => HttpEvent<TemplateContent>;
  save: (
    request: SaveTemplateRequest,
    params: HttpEventCallbacks<SaveTemplateResponse>,
  ) => HttpEvent<SaveTemplateResponse>;
  update: (
    templateId: string,
    request: UpdateTemplateRequest,
    params: HttpEventCallbacks<TemplateDTO[]>,
  ) => HttpEvent<TemplateDTO[]>;
  delete: (
    templateId: string,
    params: HttpEventCallbacks<TemplateDTO[]>,
  ) => HttpEvent<TemplateDTO[]>;
};

export const templateApiClient: TemplateApiClient = {
  getTemplates: (accountId, companyId, type, params) =>
    httpGet({ url: `/templates${toQueryString({ accountId, companyId, type })}`, ...params }),
  getContent: (templateId, companyId, params) =>
    httpGet({
      url: `/templates/${encodeURIComponent(templateId)}/content${toQueryString({ companyId })}`,
      ...params,
    }),
  save: (request, params) => httpPost({ url: "/templates", data: request, ...params }),
  update: (templateId, request, params) =>
    httpPut({ url: `/templates/${encodeURIComponent(templateId)}`, data: request, ...params }),
  delete: (templateId, params) =>
    httpDelete({ url: `/templates/${encodeURIComponent(templateId)}`, ...params }),
};
